import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getInitiateIvSelector } from '../selectors'
import { saveInitiateIv } from '../store/initiateIv.actions'
import { InitiateIvConstants } from '../store/initiateIv.constants'
import { IInitiateIvState } from '../store/initiateIv.types'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* setSuccessfulAttempt() {
  const initiateIvState: IInitiateIvState = yield select(getInitiateIvSelector)
  const { successfulAttempt } = initiateIvState
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    try {
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      if (pcrDoc.patient?.initiateIvStateList && pcrDoc.patient?.initiateIvStateList.length) {
        const index = pcrDoc.patient?.initiateIvStateList?.findIndex(
          (initiateIv) => initiateIv.key === initiateIvState.key
        )
        if (index !== -1) {
          if (pcrDoc.patient.initiateIvStateList[index].successfulAttempt !== successfulAttempt) {
            yield put(saveInitiateIv())
          }
        }
      } else {
        yield put(saveInitiateIv())
      }
    } catch (e) {
      yield put(throwPcrException(`setSuccessfulAttempt() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* setSuccessfulAttemptSaga() {
  yield takeLatest([InitiateIvConstants.SET_SUCCESSFUL_ATTEMPT], performWithMutexHOG, setSuccessfulAttempt)
}
